<xi-basic-tile [hasTopBar]="false" [isInteractive]="false" [stretch]="true">
  <div slot="children">
    <div class="simple-dialog__container">
      <div mat-dialog-title>
        <h2 class="kxi-text-600">{{ title | titlecase }}</h2>
      </div>

      <div mat-dialog-content>
        <p class="kxi-text-normal">{{ content }}</p>
        @if (extraContent) {
          <p class="kxi-text-normal">{{ extraContent }}</p>
        }
      </div>

      <div mat-dialog-actions class="simple-dialog__actions" #actionButtons>
        @if (!disableCancel) {
          <div>
            <xi-default-button
              [text]="cancelTitle"
              fill="text"
              buttonSize="small"
              (onClick)="cancel()"
            ></xi-default-button>
          </div>
        }

        <div class="fill-space"></div>

        @for (button of buttons; track button) {
          <div class="simple-dialog__actions-button">
            <xi-default-button
              [text]="button.title"
              fill="outline"
              buttonSize="small"
              (onClick)="onButtonClick(button)"
            ></xi-default-button>
          </div>
        }
        @if (confirmTitle) {
          <div>
            <xi-default-button
              [text]="confirmTitle"
              [color]="confirmColor"
              [disabled]="options.confirmButtonDisabled"
              [tooltip]="
                options.confirmButtonDisabled
                  ? { text: options.confirmButtonDisabledTooltip }
                  : null
              "
              [tooltipDisplayOnDisabled]="true"
              buttonSize="small"
              (onClick)="confirm()"
            ></xi-default-button>
          </div>
        }
      </div>
    </div>
  </div>
</xi-basic-tile>
